export const exhaustiveMatchingGuard = <T>(_: never, message: string): T => {
	throw new Error(message);
};
